import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { T } from '../traks';
import { PortfolioWithResolve } from '../c/Portfolio';

const G = (props) => props.children;

var ExploreCOMM = (props) => {
	var sections = [];

	sections.push(
		<Container key="this_is_the_unique_key_for_the_commodity_portfolio_container" className="pb-3">
		<Row key="this_is_the_unique_key_for_the_commodity_title_row">
			<Col xs="12" className="pb-3">
				<h3 className="pt-5"><T>All commodities</T></h3>
			</Col>
		</Row>
		<Row key="this_is_the_unique_key_for_the_commodity_portfolio_row" className="ad_notification_box">
			<Col md="12">
				<PortfolioWithResolve show_title={false} include_chart={false} portfolio_id={134}/>
			</Col>
		</Row>
		</Container>
	);

	return (
		<G>
			<div className="d-flex flex-column text-center ad_explore_large_img_comm justify-content-center">
				<div className="pt-5 text-white ad_explore_txt_header"><T>Commodities</T></div>
				<div className="text-white pb-3 ad_explore_txt_subheader px-2"><T>Explore commodities</T></div>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

ExploreCOMM = Apify("/z/explore?market=COMMODITIES")
	.with_response_prop("home")
	.wrap(ExploreCOMM, ApifyFullScreenLoadingComponent);

export default ExploreCOMM;



// WEBPACK FOOTER //
// ./src/p/ExploreCOMM.js